import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const playerSlice = createSlice({
  initialState: {
    audioReloadAttempts: 0 as number,
    currentTime: 0 as number,
    duration: 0 as number,
    loop: undefined as [number, number] | undefined,
    playing: false,
    speed: 1 as number,
    url: undefined as string | undefined,
  },
  name: 'player',
  reducers: {
    audioReloadFailed: (state) => {
      state.audioReloadAttempts += 1
      return state
    },
    /** Loops playback between two times; called without a payload to stop looping. */
    loop: (state, action: PayloadAction<[number, number] | undefined>) => {
      state.loop = action.payload
      return state
    },
    resetAudioReload: (state) => {
      state.audioReloadAttempts = 0
      return state
    },
    pause: (state) => {
      state.playing = false
      return state
    },
    play: (state) => {
      state.playing = true
      return state
    },
    seek: (state, action: PayloadAction<number>) => {
      state.currentTime = action.payload
      return state
    },
    setSpeed: (state, action: PayloadAction<number>) => {
      state.speed = action.payload
      return state
    },
    /**
     * Loads a recording into the player. A record without audio leaves the player without a url;
     * an unknown duration is stored as 0, the player's initial duration.
     */
    setUrl: (state, action: PayloadAction<{ url: string | null; duration: number | null }>) => {
      return {
        audioReloadAttempts: state.audioReloadAttempts,
        currentTime: 0,
        duration: action.payload.duration ?? 0,
        loop: undefined,
        playing: false,
        speed: 1,
        url: action.payload.url ?? undefined,
      }
    },
  },
})

export const {
  audioReloadFailed,
  loop,
  pause,
  play,
  resetAudioReload,
  seek,
  setSpeed,
  setUrl,
} = playerSlice.actions
